
import HTMLEmbeddingDraggableNudge from "../../DraggableNudge/HTMLEmbeddingDraggableNudge";
import React, { useEffect, useRef, useState } from "react";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import NudgeFields from "../FirstTimePersonaNudge/NudgeFields";
import NudgeOptions from "../FirstTimePersonaNudge/NudgeOptions";
import NudgeFieldsURL from "../FirstTimePersonaNudge/NudgeFieldsURL";
import LeadCapturedPreview from "../../PreviewNudge/LeadCapturedPreview";
import ToggleSwitch from "../FirstTimePersonaNudge/ToggleSwitch";
import ReferrerSites from "../FirstTimePersonaNudge/ReferrerSites/ReferrerSites";
import UrlQueryParams from "../FirstTimePersonaNudge/UrlQueryParams/UrlQueryParams";
import PersonaNudgeTitle from "../FirstTimePersonaNudge/PersonaNudgeTitle";
import { createHTMLEmbeddingPersonaState } from "../../../../helper/customizedNudge/HTMLEmbedding";
import { handleSaveHTMLEmbeddingNudge } from "../../../../helper/customizedNudge/handleSaveHTMLEmbeddingNudge";


const HTMLEmbeddingNudge = (props) => {
  // console.log("props", props);
  let { nudgeData, nudgeId, isLoading, user, nudgeText, userPersonas,
    setUserPersonas, userPersonaKey, handleSaveUserPersonas} = props;
  const activeButton = useRef(null);
  const [nudgeFields, setNudgeFields] = useState({});
  const [customizeState, setCustomizeState] = useState({});
  const [nudgePosition, setNudgePosition] = useState({
    desktop: { top: 0, left: 0 },
    mobile: { top: 0 },
  });
  const [nudgeMode, setNudgeMode] = useState("desktop");
  useEffect(() => {
    console.log("nudgeData", nudgeData);
    if (nudgeData) {
      activeButton.current = nudgeData.nudgeOfferText.optionValue;
      setNudgeFields(nudgeData.nudgeOfferText);
      const state = createHTMLEmbeddingPersonaState(nudgeData);
      setCustomizeState(state);
      setNudgePosition(
        (prev) =>
          (prev = {
            ...prev,
            desktop: {
              top: nudgeData.nudge.nudgePosition.desktop.top,
              left: nudgeData.nudge.nudgePosition.desktop.left,
            },
            mobile: { top: nudgeData.nudge.nudgePosition.mobile.top },
          })
      );
    }
  }, [nudgeData]);

  const handleNudgeOptionClick = (option) => {
    setNudgeFields(option);
    activeButton.current = option.optionValue;
  };
  const { optionName: nudgeTitle, optionValue: nudgeName } = nudgeText;


  return (
    <div className="persona__nudge border border-neutral-600 dark:border-neutral-800 rounded shadow-lg shadow-blue-800 w-full p-2 sm:p-4">
      <div className="flex justify-around items-center mb-4">
        <PersonaNudgeTitle
              userPersonas={userPersonas}
              setUserPersonas={setUserPersonas}
              userPersonaKey={userPersonaKey}
        />
        <div className="absolute right-3 flex justify-center items-center">
          <ToggleSwitch
            customizeState={customizeState}
            setCustomizeState={setCustomizeState}
            nudgeData={nudgeData}
          />
          <span className="mx-2">Activate</span>
        </div>
      </div>
      <div className="optionContainer lg:flex py-8 ">
        <NudgeOptions
          nudgeData={nudgeData}
          activeButton={activeButton.current}
          handleNudgeOptionClick={handleNudgeOptionClick}
          userPersonaKey={userPersonaKey}
          customizeState={customizeState}
        />
        {activeButton.current !== "nudgeShowing" ? (
          <NudgeFields
            nudgeFields={nudgeFields}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
            handleSave={() => {
              handleSaveHTMLEmbeddingNudge(
                nudgeData,
                customizeState,
                nudgePosition,
                user,
                nudgeName
              )
              handleSaveUserPersonas() 
            }
            }
            setCustomizeState={setCustomizeState}
          />
        ) : (
          <NudgeFieldsURL
            nudgeFields={nudgeFields}
            setNudgeFields={setNudgeFields}
            customizeState={customizeState}
              handleSave={() => {
                handleSaveHTMLEmbeddingNudge(
                  nudgeData,
                  customizeState,
                  nudgePosition,
                  user,
                  nudgeName
                )
                handleSaveUserPersonas() 
            }
            }
            setCustomizeState={setCustomizeState}
          />
        )}
      </div>
      <ReferrerSites
        referrerSitesData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <UrlQueryParams
        URLqueryParamData={[]}
        customizeState={customizeState}
        setCustomizeState={setCustomizeState}
        nudgeData={nudgeData}
      />
      <hr />
      <LeadCapturedPreview
        nudgeMode={nudgeMode}
        setNudgeMode={setNudgeMode}
        customizeState={customizeState}
        nudgePosition={nudgePosition}
        nudgeId={nudgeId}
        id="desktop"
        userPersonaKey={userPersonaKey}
      />
      {isLoading.loading ? (
        <LoadingAnimation />
      ) : (
        <HTMLEmbeddingNudgeArea
          nudgeMode={nudgeMode}
          customizeState={customizeState}
          nudgeId={nudgeId}
          setNudgePosition={setNudgePosition}
          setCustomizeState={setCustomizeState}
          id="mobile"
        />
      )}
    </div>
  );
};

export default HTMLEmbeddingNudge;



const HTMLEmbeddingNudgeArea = ({
    nudgeMode,
    customizeState,
    nudgeId,
    setNudgePosition,
    setCustomizeState,
  }) => {
    const draggableDesktopRef = useRef(null);
  
    useEffect(() => {
      if (draggableDesktopRef.current) {
        let width = draggableDesktopRef.current.offsetWidth;
        draggableDesktopRef.current.height = `${Math.round(
          width / 2.057
        )}px !important`;
      }
    }, []);
  
    return (
      <>
        {nudgeMode === "desktop" ? (
          <div
            ref={draggableDesktopRef}
            className={`desktop__drag__area m-2 rounded border dark:!border-neutral-500 !border-[#0c0c0c] relative  shadow-md shadow-[#203b69]`}
            style={{
              position: "relative",
              overflow: "hidden",
              height: "573px",
            }}
          >
            <HTMLEmbeddingDraggableNudge
              key="desktop"
              customizeState={customizeState}
              nudgeId={nudgeId}
              id="desktop"
              setNudgePosition={setNudgePosition}
              setCustomizeState={setCustomizeState}
            />
          </div>
        ) : (
          <div
            className={`mobile__drag__area m-2 rounded border dark:!border-neutral-500 !border-[#0c0c0c] relative mx-auto shadow-md shadow-[#203b69]`}
            style={{
              position: "relative",
              overflow: "hidden",
              minHeight: "844px",
              maxWidth: "340px",
            }}
          >
            <HTMLEmbeddingDraggableNudge
              key="mobile"
              customizeState={customizeState}
              nudgeId={nudgeId}
              id="mobile"
              setNudgePosition={setNudgePosition}
              setCustomizeState={setCustomizeState}
            />
          </div>
        )}
      </>
    );
};
  